import { apiClient } from 'src/utils/api-client';
import {
  PayoutPlanVariationModel,
  SettingsModel,
  SiteVisitInfo,
} from './models';

export function fetchPayoutPlansService() {
  return apiClient.get<PayoutPlanVariationModel[]>(`/payout-plans`);
}

export function fetchSettingsService() {
  return apiClient.get<SettingsModel>(`/settings`);
}

// We use the url to track UTM in the params.
export function trackSiteVisitService(
  trackingId: string,
  partnerKey?: string,
  experiments?: Record<string, string>,
  userUniqueId?: string,
) {
  return apiClient.post<void>(
    '/sitevisit',
    {
      trackingId,
      url: window.location.href,
      referrer: document.referrer,
      encodedPartnerKey: partnerKey,
      experiments,
      userUniqueId,
    } satisfies SiteVisitInfo,
    {
      keepalive: true,
    },
  );
}
